export default "__VITE_ASSET__Bbk47tXd__"